module.exports = require("chartjs-plugin-datalabels");